'use client';
import Image from 'next/image';
import NavLink from '@/app/_components/navLink';
import { DAVINCI_CDN } from '@/routes';

const Page = () => {
  return (
    <>
      <div className="bg-neutral-surface pt-16 pb-32">
        <div className="grid grid-cols-[1fr] justify-items-center gap-y-10">
          <div className="relative h-56 w-56 md:h-72 md:w-72 lg:h-80 lg:w-80">
            <Image src={`${DAVINCI_CDN}/elty/404.jpg`} alt="Pagina non trovata" fill />
          </div>
          <h1 className="text-xl md:text-3xl lg:text-4xl font-semibold text-neutral-darker text-center">
            Oops! Hai trovato una pagina <br className="block lg:hidden" /> che non esiste
          </h1>
          <p className="text-base md:text-xl lg:text-2xl font-normal text-neutral-lighter text-center">
            Non preoccuparti, torna alla home e ti
            <br />
            aiuteremo a trovare quello che cerchi
          </p>
          <NavLink href={'/'} variant="filled" color="secondary" aria-label="Torna alla home" label="Torna alla home" />
        </div>
      </div>
    </>
  );
};

export default Page;
